(function() {
  // ── Alia popup shield fix ──
  // Alia's app injects a full-viewport, max-z-index, transparent host div
  // that intercepts EVERY tap on the page (site-wide dead buttons). Its
  // shadow root is open, so we make the host click-transparent while its
  // actual widgets (chip / popup) stay interactive.
  function fixAliaShield(root) {
    // v2: the restore rule needs !important too — without it everything in
    // the shadow root inherited the host's none and Alia's own popup
    // buttons went dead (Shane 2026-07-29, iPhone: popup undismissable).
    if (!root.shadowRoot || root.dataset.namaShieldFixed === '2') return;
    try {
      var st = document.createElement('style');
      st.textContent = ':host { pointer-events: none !important; } :host > *:not(style) { pointer-events: auto !important; }';
      root.shadowRoot.appendChild(st);
      root.dataset.namaShieldFixed = '2';
    } catch (e) { /* non-critical */ }
  }
  function sweepAlia() {
    document.querySelectorAll('div[id^="alia-root"]').forEach(fixAliaShield);
  }
  sweepAlia();
  if (window.MutationObserver && document.body) {
    new MutationObserver(sweepAlia).observe(document.body, { childList: true });
  }

  // ── Early drawer fallback ──
  // The theme's open/close handlers live in utilities.js, which loads after
  // the heavy app scripts — taps during that window did nothing. This binds
  // immediately and steps aside once the theme's handler exists.
  function themeMenuReady() {
    return window.PXUTheme && window.PXUTheme.mobileMenu && window.PXUTheme.mobileMenu.$mobileMenuToggle;
  }
  function fallbackToggle(open) {
    document.body.classList.toggle('mobile-menu--opened', open);
    document.querySelectorAll('[data-show-mobile-menu]').forEach(function (el) {
      el.setAttribute('data-show-mobile-menu', open ? 'true' : 'false');
    });
    document.querySelectorAll('.mobile-menu__toggle-icon').forEach(function (el) {
      el.classList.toggle('is-active', open);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.mobile-menu__toggle-icon[data-show-mobile-menu]');
    if (!t || themeMenuReady()) return; // theme JS is up — let it handle taps
    e.preventDefault();
    e.stopPropagation();
    fallbackToggle(t.getAttribute('data-show-mobile-menu') !== 'true');
  }, true);

  // Accordion toggle
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.mmc-accordion__trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var accordion = trigger.closest('.mmc-accordion');
    if (accordion) {
      accordion.classList.toggle('is-open');
    }
  });

  // Close button inside the full-screen drawer (works pre-theme-JS too)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mmc-drawer-close]')) {
      e.preventDefault();
      e.stopPropagation();
      if (themeMenuReady()) {
        window.PXUTheme.mobileMenu.close();
      } else {
        fallbackToggle(false);
      }
    }
  });

  // Prevent menu link clicks from bubbling up to the body-level
  // delegated handler that closes the menu on any click inside
  // [data-show-mobile-menu="true"]
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.mmc-drawer a[href]');
    if (link) {
      e.stopPropagation();
    }
  }, true);

  // --- Mobile search overlay ---
  var overlay = document.querySelector('[data-mmc-search-overlay]');
  if (!overlay) return;

  // Move overlay to body so it escapes the mobile header stacking context
  document.body.appendChild(overlay);

  var input = overlay.querySelector('[data-mmc-search-input]');
  var form = overlay.querySelector('[data-mmc-search-form]');
  var resultsWrapper = overlay.querySelector('[data-mmc-search-results]');
  var trending = overlay.querySelector('[data-mmc-trending]');
  var popular = overlay.querySelector('[data-mmc-popular]');
  var debounceTimer = null;

  function openOverlay() {
    overlay.classList.add('is-open');
    setTimeout(function() { input.focus(); }, 100);
    trending.style.display = '';
    if (popular) popular.style.display = '';
    resultsWrapper.innerHTML = '';
    resultsWrapper.style.display = 'none';
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    input.value = '';
    resultsWrapper.innerHTML = '';
    resultsWrapper.style.display = 'none';
    trending.style.display = '';
    if (popular) popular.style.display = '';
  }

  // Open trigger
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-mmc-search-open]')) {
      e.preventDefault();
      e.stopPropagation();
      openOverlay();
    }
  });

  // Close trigger
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-mmc-search-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeOverlay();
    }
  });

  // Trending pill tap — fill input and show predictive results (don't navigate)
  document.addEventListener('click', function(e) {
    var pill = e.target.closest('[data-mmc-trending-pill]');
    if (!pill) return;
    e.preventDefault();
    e.stopPropagation();
    var keyword = pill.getAttribute('data-mmc-trending-pill');
    input.value = keyword;
    input.focus();
    fetchResults(keyword);
  });

  // Predictive search on input
  input.addEventListener('input', function() {
    var term = input.value.trim();
    clearTimeout(debounceTimer);
    if (term.length === 0) {
      resultsWrapper.innerHTML = '';
      resultsWrapper.style.display = 'none';
      trending.style.display = '';
      if (popular) popular.style.display = '';
      return;
    }
    debounceTimer = setTimeout(function() {
      fetchResults(term);
    }, 200);
  });


  // Collections come back inside the generic Suggestions <ul> (queries and
  // collections share it). Lift them into their own labelled group so they
  // read as destinations, not search-term guesses.
  function splitCollections(results, prefix) {
    var ul = results.querySelector('.search__results__suggestions ul');
    if (!ul) return;
    var cols = Array.prototype.filter.call(ul.querySelectorAll('li'), function (li) {
      var a = li.querySelector('a');
      return a && a.getAttribute('href') && a.getAttribute('href').indexOf('/collections/') > -1;
    });
    if (!cols.length) return;
    var group = document.createElement('div');
    group.className = prefix + '-col-group';
    var label = document.createElement('p');
    label.className = prefix + '-col-group__label';
    label.textContent = 'Collections';
    var row = document.createElement('div');
    row.className = prefix + '-col-group__row';
    cols.slice(0, 1).forEach(function (li) {
      var a = li.querySelector('a');
      var chip = document.createElement('a');
      chip.className = prefix + '-col-chip';
      chip.href = a.getAttribute('href');
      chip.textContent = a.textContent.trim();
      row.appendChild(chip);
      li.remove();
    });
    cols.slice(1).forEach(function (li) { li.remove(); });
    group.appendChild(label); group.appendChild(row);
    var sug = results.querySelector('.search__results__suggestions');
    // no query suggestions left? drop the empty Suggestions block
    if (sug && !sug.querySelectorAll('li').length) sug.remove();
    results.insertBefore(group, results.firstChild);
  }

  function fetchResults(term) {
    if (!term || term.length === 0) return;
    trending.style.display = 'none';
    if (popular) popular.style.display = 'none';
    var url = window.PXUTheme.routes.predictive_search_url
      + '?q=' + encodeURIComponent(term)
      + '&resources[limit]=10&resources[limit_scope]=each'
      + '&resources[type]=product,collection'
      + '&resources[options][fields]=title,product_type,tag,body,vendor'
      + '&section_id=predictive-search';
    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var results = doc.querySelector('.search__results');
        var allBtn = doc.querySelector('.all-results');
        if (results || allBtn) {
          resultsWrapper.innerHTML = '';
          if (results) {
            // De-clutter (per Shane): max 3 suggestions, no Pages in the
            // type-ahead — pages still surface on the full results page.
            splitCollections(results, 'mmc');
          var sugg = results.querySelectorAll('.search__results__suggestions li');
            Array.prototype.slice.call(sugg, 3).forEach(function (li) { li.remove(); });
            var pages = results.querySelector('.search__results__pages-posts');
            if (pages) pages.remove();
            resultsWrapper.appendChild(results);
          }
          // no 'Search for "term"' CTA — typing already implies the search;
          // keyboard Go / the magnifier submit reach the full results page
          resultsWrapper.style.display = 'block';
        } else {
          var noResults = doc.querySelector('.no-results');
          resultsWrapper.innerHTML = noResults ? noResults.outerHTML : '';
          resultsWrapper.style.display = 'block';
        }
      });
  }

  // Submit form
  form.addEventListener('submit', function(e) {
    var term = input.value.trim();
    if (term.length === 0) {
      e.preventDefault();
    }
  });
})();
